<template>
  <div class="d-flex text-white">
    <div>
      <p class="nav-user-data">{{ userData.fname }} {{ userData.lname }} </p>
       <p class="nav-user-data">{{ userData.companyName }} </p>
    </div>
    <ul class="nav-user-contact-list">
      <li v-for="(route, index) in menu" :key="index">
        <router-link :to="{name:route.routeName}"  class="mx-1">
            <b-iconstack font-scale="1" v-b-tooltip.hover.left :title="route.label">
              <b-icon stacked icon="square"></b-icon>
              <b-icon stacked :icon="route.icon"></b-icon>
            </b-iconstack>
          </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import authMixin from '../mixins/auth'
import { secondary } from '../nav'
export default {
  name: 'userInformations',
  mixins: [authMixin],
  data () {
    return {
      menu: secondary
    }
  }
}
</script>

<style lang="scss" scoped>
  a {
    color:white;
    transition: color .3s ease-in;
    & hover{
      color:grey;
    }
  }
</style>
